import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { PageHeader, Surface, Button, Modal, Input, Select, NewButton } from "@/components/ui-kit";

const empty = { name: "", contact_person: "", phone: "", email: "", address: "", category: "spares" };

export default function Vendors() {
    const [list, setList] = useState([]);
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState(empty);
    const [editing, setEditing] = useState(null);

    const load = () => api.get("/vendors").then((r) => setList(r.data));
    useEffect(() => { load(); }, []);

    const save = async () => {
        try {
            if (editing) await api.put(`/vendors/${editing}`, form);
            else await api.post("/vendors", form);
            toast.success("Saved"); setOpen(false); setEditing(null); setForm(empty); load();
        } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    };
    const edit = (v) => { setForm({ ...empty, ...v }); setEditing(v.id); setOpen(true); };
    const del = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/vendors/${id}`); load(); };

    return (
        <div className="p-6 lg:p-8 animate-fade-in">
            <PageHeader
                eyebrow="PARTNERS"
                title="Vendors"
                subtitle={`${list.length} vendors`}
                action={<NewButton onClick={() => { setForm(empty); setEditing(null); setOpen(true); }} label="Add vendor" testid="add-vendor-btn" />}
            />

            <Surface className="overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-slate-50"><tr className="text-left">
                        {["NAME", "CATEGORY", "CONTACT", "PHONE", "EMAIL", ""].map((h) => <th key={h} className="label-mono px-5 py-3 font-normal">{h}</th>)}
                    </tr></thead>
                    <tbody>
                        {list.map((v) => (
                            <tr key={v.id} className="border-t border-fleet-border data-grid-row">
                                <td className="px-5 py-3 font-medium">{v.name}</td>
                                <td className="px-5 py-3 capitalize">{v.category}</td>
                                <td className="px-5 py-3">{v.contact_person || "—"}</td>
                                <td className="px-5 py-3 font-mono">{v.phone || "—"}</td>
                                <td className="px-5 py-3 font-mono text-xs">{v.email || "—"}</td>
                                <td className="px-5 py-3 text-right">
                                    <Button variant="ghost" size="sm" onClick={() => edit(v)} data-testid={`edit-vendor-${v.id}`}>Edit</Button>
                                    <Button variant="ghost" size="sm" onClick={() => del(v.id)} data-testid={`del-vendor-${v.id}`}>Del</Button>
                                </td>
                            </tr>
                        ))}
                        {list.length === 0 && <tr><td colSpan={6} className="px-5 py-10 text-center text-sm text-fleet-inkSoft">No vendors yet.</td></tr>}
                    </tbody>
                </table>
            </Surface>

            <Modal open={open} onClose={() => setOpen(false)} title={editing ? "Edit vendor" : "Add vendor"}
                footer={<><Button variant="secondary" onClick={() => setOpen(false)}>Cancel</Button><Button onClick={save}>Save</Button></>}>
                <div className="grid grid-cols-2 gap-4">
                    <Input label="Name" className="col-span-2" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                    <Select label="Category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}
                        options={["spares", "tyres", "batteries", "lubricants", "workshop", "fuel"]} />
                    <Input label="Contact person" value={form.contact_person} onChange={(e) => setForm({ ...form, contact_person: e.target.value })} />
                    <Input label="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                    <Input label="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                    <Input label="Address" className="col-span-2" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />
                </div>
            </Modal>
        </div>
    );
}
